import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import useTokenInfo from "../../../hooks/useTokenInfo";
// import FlipNumbers from "react-flip-numbers";
import useStrictBackBlock from "../../../bridges/useStrictBackBlock";
import useImageListStore from '../../../stores/imageList';
import WizLoadingCircle from "../../../assets/components/WizLoadingCircle";
import checkOn from "../../../assets/icons/Select/check_checked.svg"
import checkOff from "../../../assets/icons/Select/check_unchecked.svg"

const AutoMarketingPromptLoading = () => {
    const location = useLocation();
    const { data } = location.state;
    const storeBusinessNumber = data.store_business_number
    const navigate = useNavigate();
    // const [, setRegisterTag] = useState(() => localStorage.getItem("registerTag") || "");
    const { getImageList } = useImageListStore();

    const imageList = getImageList(storeBusinessNumber) || [];
    const styleId = Number(localStorage.getItem("aiStyle")
    )
    // 스타일별 랜덤 이미지 골라주는 함수
    const pickRandomImageByStyle = (images, styleId) => {
        if (!Array.isArray(images) || images.length === 0) return null;

        // style과 design_id가 같은 것만 필터
        const filtered = images.filter((img) => img.design_id === styleId);

        // 해당 스타일이 하나도 없으면 전체에서 랜덤 (fallback)
        const pool = filtered.length > 0 ? filtered : images;

        const randomIndex = Math.floor(Math.random() * pool.length);
        const picked = pool[randomIndex];

        // 필요한 필드만 추려서 반환 (ImageItemMain 형태)
        const { path, prompt, design_id } = picked;
        return { path, prompt, design_id };
    };

    // 기존 data 에서 image_list만 제거
    const { image_list, ...restData } = data;

    // 랜덤 이미지 1개 선택
    const pickedImage = pickRandomImageByStyle(imageList, styleId);

    const [stepStates, setStepStates] = useState(["idle", "idle", "idle"]);
    const {
        tokenInfo,
        fetchTokenInfo,
        deductToken,
    } = useTokenInfo();

    useEffect(() => {
        const timers = [];

        const sendGenerateRequest = async (timers, token) => {
            // 단계별 메시지 시작
            setStepStates(["loading", "idle", "idle"]);
            timers.push(setTimeout(() => setStepStates(["done", "loading", "idle"]), 1200));
            timers.push(setTimeout(() => setStepStates(["done", "done", "loading"]), 2200));

            const start = Date.now();
            // const userIdStr = localStorage.getItem("user_id");
            // const userId = userIdStr && userIdStr.trim() !== "" ? parseInt(userIdStr, 10) : null;
            const latestTag = localStorage.getItem("registerTag");
            const mainData = {
                ...restData,
                register_tag: latestTag ?? data.register_tag ?? "",
                // 백엔드가 ImageItemMain 단일 객체를 기대하므로 그대로 넣기
                ...(pickedImage && { image_list: pickedImage }),
            };


            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/auto/prompt/app`,
                    mainData,
                    {
                        headers: { "Content-Type": "application/json" },
                    }
                );
                // const raw = response.data?.register_tag;
                // const fallback = data?.register_tag ?? localStorage.getItem("registerTag") ?? "";
                // const nextTag = (raw ?? "").trim() || fallback;   // ← 항상 최종값 확정
                // localStorage.setItem("registerTag", nextTag);      // ← 로컬스토리지 동기화
                // setRegisterTag(nextTag);                           // ← 상태도 동기화
                const end = Date.now();

                const elapsed = end - start;
                const MIN_DISPLAY_TIME = 3000;
                const remaining = elapsed < MIN_DISPLAY_TIME ? MIN_DISPLAY_TIME - elapsed : 0;

                let tokenAll = null
                if (response.status === 200) {
                    try {
                        tokenAll = await deductToken(token);
                    } catch (err) {
                        console.error("토큰 차감 실패: ", err)
                    }
                }

                // ✅ 스타일 분석 완료 메시지를 응답 기준으로 보여줌
                timers.push(setTimeout(() => {
                    setStepStates(["done", "done", "done"]);
                }, remaining));

                // ✅ 결과 페이지 이동
                timers.push(setTimeout(() => {

                    const resultData = [
                        {
                            ...response.data,
                            // manual/marketing/ai/result 쪽에서 기대하는 형태로 맞춤
                            menu: latestTag ?? data.register_tag ?? "",
                            prompt: pickedImage?.prompt ?? "",
                            ad_text:
                                response.data?.copyright ??
                                response.data?.ad_text ??
                                response.data?.ad_text_override ??
                                "",
                            ad_text_theme: response.data?.ad_text_theme ?? "",
                            ad_text_override:
                                response.data?.ad_text_override ??
                                response.data?.customText ??
                                "",
                            tokenAll,
                        },
                    ];

                    navigate(`/manual/marketing/ai/result/`, {
                        state: resultData,
                    });
                }, remaining + 800)); // 문구 약간 보여준 후 이동

            } catch (error) {
                console.error("자동화 광고 생성 중 오류:", error);
                alert("이미지 생성에 실패하였습니다.");
                navigate(-1);
            }
        };

        const init = async () => {
            try {
                const total = await fetchTokenInfo();
                if (!Number.isFinite(total) || total <= 0) {
                    alert("이용 가능한 토큰이 없습니다. 결제 페이지로 이동합니다.");
                    return navigate("/myticket", { state: { storeBusinessNumber } });
                }

                await sendGenerateRequest(timers, total);
            } catch (err) {
                console.error("토큰 검사 중 오류:", err);
                alert("토큰 정보를 불러오는 중 오류가 발생했습니다.");
                navigate("/myticket", { state: { storeBusinessNumber } });
            }
        };

        init();
        return () => timers.forEach(clearTimeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const renderStep = (status, label) => {
        if (status === "loading") {
            return (
                <div className="flex items-center space-x-2 text-text-subtler text-b1">
                    <img src={checkOff} alt="" />
                    <span>{label} 분석 중</span>
                </div>
            );
        } else if (status === "done") {
            return (
                <div className="flex items-center space-x-2 text-text-primary text-b1">
                    <img src={checkOn} alt="" />
                    <span>{label} 분석 완료</span>
                </div>
            );
        }

        return (
            <div className="flex items-center space-x-2 text-text-subtler text-b1">
                <img src={checkOff} alt="" className="opacity-40" />
                <span>{label} 분석 예정</span>
            </div>
        );
    };

    useStrictBackBlock(true);

    return (
        <div className="fixed inset-0 bg-white z-50 flex flex-col justify-center items-center">
            {/* <div className="text-5xl text-purple-500 pb-8 animate-bounce">
                <svg className="w-16 h-16" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0z" />
                </svg>
            </div> */}
            <WizLoadingCircle />
            <p className="text-center text-t2 text-text-default pb-[24px] ">AI 이미지를 생성하고 있습니다.</p>
            <div className="text-center text-b1 text-text-subtle pb-[12px]">
                {renderStep(stepStates[0], "홍보 메뉴")}
                {renderStep(stepStates[1], "홍보 내용")}
                {renderStep(stepStates[2], "스타일")}
            </div>

            <div className="fixed bottom-[64px]">
                <p className="text-c2 text-text-subtle pb-[4px]">1개의 토큰을 사용하고 있어요</p>
                <div className="text-center text-c1 text-text-primary">
                    {Number.isFinite(tokenInfo.total) ? (
                        <>
                            잔여 토큰{" "}
                            <div className="inline-flex">
                                {/* <FlipNumbers
                                height={16}
                                width={12}
                                color="#6B21A8"
                                background="transparent"
                                numbers={tokenInfo.total.toString()}
                                play
                                duration={1.3}
                                perspective={80}
                            /> */}
                                {tokenInfo.total.toString()}
                            </div>
                        </>
                    ) : (
                        `(잔여 토큰 로딩중...)`
                    )}
                </div>
            </div>
        </div>
    );
};

export default AutoMarketingPromptLoading;
